module.exports = __webpack_public_path__ + "media/icons/offer-details-rolnicze-f32ac253.png";